module.exports = __webpack_public_path__ + "img/LUCIA.7b91c9ee.png";